import { Link } from '@mui/material';

export const SUPPORT_EMAIL = 'support@mvision.ai';

/** A mailto link to MVision customer support, showing the address itself. */
const SupportEmailLink = () => (
    <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>
);

export default SupportEmailLink;
